import { createSelector } from '@ngrx/store';
import {
  WikiReadersReportActions,
  WikiReadersReportActionTypes,
  LoadFailureAction,
  LoadSuccessAction,
} from './wiki-readers-report.actions';

export interface State {
  rowsByWikiId: { [wikiId: string]: any[] };
  loadingByWikiId: { [wikiId: string]: boolean };
  errorsByWikiId: { [wikiId: string]: any };
}

export const initialState: State = {
  rowsByWikiId: {},
  loadingByWikiId: {},
  errorsByWikiId: {},
};

export function reducer(state = initialState, action: WikiReadersReportActions): State {
  switch (action.type) {
    case WikiReadersReportActionTypes.LoadAction: {
      return {
        ...state,
        loadingByWikiId: {
          ...state.loadingByWikiId,
          [action.wikiId]: true,
        },
        errorsByWikiId: {
          ...state.errorsByWikiId,
          [action.wikiId]: null,
        },
      };
    }

    case WikiReadersReportActionTypes.LoadSuccessAction: {
      const { wikiId, payload } = action as LoadSuccessAction;
      return {
        ...state,
        rowsByWikiId: {
          ...state.rowsByWikiId,
          [wikiId]: payload || [],
        },
        loadingByWikiId: {
          ...state.loadingByWikiId,
          [wikiId]: false,
        },
        errorsByWikiId: {
          ...state.errorsByWikiId,
          [wikiId]: null,
        },
      };
    }

    case WikiReadersReportActionTypes.LoadFailureAction: {
      const { wikiId, payload } = action as LoadFailureAction;
      return {
        ...state,
        loadingByWikiId: {
          ...state.loadingByWikiId,
          [wikiId]: false,
        },
        errorsByWikiId: {
          ...state.errorsByWikiId,
          [wikiId]: payload,
        },
      };
    }

    default:
      return state;
  }
}

export const getRowsByWikiIdMap = (state: State) => state.rowsByWikiId;
export const getLoadingByWikiIdMap = (state: State) => state.loadingByWikiId;
export const getErrorsByWikiIdMap = (state: State) => state.errorsByWikiId;

export const getRowsByWikiId = (wikiId: string) =>
  createSelector(getRowsByWikiIdMap, (rowsByWikiId) => rowsByWikiId[wikiId] || []);

export const getLoadingByWikiId = (wikiId: string) =>
  createSelector(getLoadingByWikiIdMap, (loadingByWikiId) => !!loadingByWikiId[wikiId]);

export const getErrorsByWikiId = (wikiId: string) =>
  createSelector(getErrorsByWikiIdMap, (errorsByWikiId) => errorsByWikiId[wikiId]);
